import {
  BULK_GUSTO_INVITE,
  BULK_GUSTO_INVITE_FAILURE,
  BULK_GUSTO_INVITE_SUCCESS,
  CREATE_GUSTO_PAYROLL_SYNC,
  CREATE_GUSTO_PAYROLL_SYNC_FAILURE,
  CREATE_GUSTO_PAYROLL_SYNC_SUCCESS,
  DELETE_GUSTO_INTEGRATION,
  DELETE_GUSTO_INTEGRATION_FAILURE,
  DELETE_GUSTO_INTEGRATION_SUCCESS,
  ENABLE_INTEGRATION_WORKFLOW,
  ENABLE_INTEGRATION_WORKFLOW_FAILURE,
  ENABLE_INTEGRATION_WORKFLOW_SUCCESS,
  GET_ALL_INTEGRATIONS_LIST,
  GET_ALL_INTEGRATIONS_LIST_FAILURE,
  GET_ALL_INTEGRATIONS_LIST_SUCCESS,
  GET_ENABLED_INTEGRATIONS_LIST,
  GET_ENABLED_INTEGRATIONS_LIST_FAILURE,
  GET_ENABLED_INTEGRATIONS_LIST_SUCCESS,
  GET_GUSTO_COMPANY_DETAILS,
  GET_GUSTO_COMPANY_DETAILS_FAILURE,
  GET_GUSTO_COMPANY_DETAILS_SUCCESS,
  GET_GUSTO_EMPLOYEE_LIST,
  GET_GUSTO_EMPLOYEE_LIST_FAILURE,
  GET_GUSTO_EMPLOYEE_LIST_SUCCESS,
  GET_INTEGRATIONS_FEATURES,
  GET_INTEGRATIONS_FEATURES_FAILURE,
  GET_INTEGRATIONS_FEATURES_SUCCESS,
  GET_INTEGRATION_ENABLED_WORKFLOWS_LIST,
  GET_INTEGRATION_ENABLED_WORKFLOWS_LIST_FAILURE,
  GET_INTEGRATION_ENABLED_WORKFLOWS_LIST_SUCCESS,
  GET_INTEGRATION_WORKFLOWS_LIST,
  GET_INTEGRATION_WORKFLOWS_LIST_FAILURE,
  GET_INTEGRATION_WORKFLOWS_LIST_SUCCESS,
  RUN_INTEGRATION_WORKFLOW,
  RUN_INTEGRATION_WORKFLOW_FAILURE,
  RUN_INTEGRATION_WORKFLOW_SUCCESS,
  UPDATE_GUSTO_COMPANY_LOGO,
  UPDATE_GUSTO_COMPANY_LOGO_FAILURE,
  UPDATE_GUSTO_COMPANY_LOGO_SUCCESS,
  UPDATE_GUSTO_INTEGRATION,
  UPDATE_GUSTO_INTEGRATION_FAILURE,
  UPDATE_GUSTO_INTEGRATION_SUCCESS,
  UPDATE_INTEGRATIONS_FEATURES,
  UPDATE_INTEGRATIONS_FEATURES_FAILURE,
  UPDATE_INTEGRATIONS_FEATURES_SUCCESS,
} from "../../modules/constants";
import { createNotification } from "../../modules/notificationManager";

// ------------------------------------
// Action handler methods
// ------------------------------------

//update feature settins

export const updateIntegrationsFeaturesRequest = (state, action) => {
  return {
    ...state,
  };
};

export const updateIntegrationsFeaturesSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  const updatedFeatureIndex = state.featuresList.findIndex(
    feature => feature.id === data.data.id,
  );
  if (updatedFeatureIndex !== -1) {
    const updatedFeaturesData = [...state.featuresList];
    updatedFeaturesData[updatedFeatureIndex] = data.data;

    createNotification(
      "success",
      "Integration settings updated successfully",
      2000,
    );

    return {
      ...state,
      featuresList: updatedFeaturesData,
    };
  }

  return {
    ...state,
  };
};

export const updateIntegrationsFeaturesFailure = (state, action) => {
  createNotification(
    "error",
    "Could not update the settings. Please try again!",
    2500,
  );
  return {
    ...state,
  };
};

//Integration Feature
export const handleAllIntegrationsFeaturesRequest = (state, action) => {
  return {
    ...state,
    integrationFeaturesLoading: true,
  };
};

export const handleAllIntegrationsFeaturesRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      integrationFeaturesLoading: false,
      featuresList: data.data,
    };
  }
  return {
    ...state,
    integrationFeaturesLoading: false,
    featuresList: null,
  };
};

export const handleAllIntegrationsFeaturesRequestFailure = (state, action) => {
  createNotification(
    "error",
    "Could not fetch integration list. Please try again!",
    2500,
  );
  return {
    ...state,
    integrationFeaturesLoading: false,
    featuresList: null,
  };
};

export const handleAllIntegrationsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const handleAllIntegrationsListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      allIntegrationsList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    allIntegrationsList: null,
  };
};
export const handleAllIntegrationsListRequestFailure = (state, action) => {
  createNotification(
    "error",
    "Could not fetch integration list. Please try again!",
    2500,
  );
  return {
    ...state,
    isLoading: false,
    allIntegrationsList: null,
  };
};

export const handleIntegrationWorkflowsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const handleIntegrationWorkflowsListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    const result = JSON.parse(JSON.stringify(data.data));
    if (result && result.length > 0) {
      result.forEach(item => {
        item.is_enabled = false;
      });
    }
    return {
      ...state,
      isLoading: false,
      integrationWorkflowsList: [...result],
    };
  }
  return {
    ...state,
    isLoading: false,
    integrationWorkflowsList: null,
  };
};
export const handleIntegrationWorkflowsListRequestFailure = (state, action) => {
  createNotification(
    "error",
    "Could not fetch integration workflows list. Please try again!",
    2500,
  );
  return {
    ...state,
    isLoading: false,
    integrationWorkflowsList: null,
  };
};

export const handleEnabledIntegrationsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const handleEnabledIntegrationsListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      enabledIntegrationsList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    enabledIntegrationsList: null,
  };
};
export const handleEnabledIntegrationsListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    enabledIntegrationsList: null,
  };
};

export const handleEnabledWorkflowsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
  };
};
export const handleEnabledWorkflowsListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      enabledWorkflowsList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    enabledWorkflowsList: null,
  };
};
export const handleEnabledWorkflowsListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    enabledWorkflowsList: null,
  };
};

export const handleEnableWorkflowRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
  };
};
export const handleEnableWorkflowRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    createNotification("success", "Workflow enabled successfully", 2000);
    if (data.data && data.data.id) {
      const workflowsList = JSON.parse(
        JSON.stringify(state.integrationWorkflowsList),
      );
      workflowsList.some(workflow => {
        if (workflow.name === data.data.name) {
          workflow.is_enabled = true;
          return true;
        }
        return false;
      });

      return {
        ...state,
        isLoading: false,
        integrationWorkflowsList: [...workflowsList],
        enabledWorkflowData: data.data,
      };
    }
    return {
      ...state,
      isLoading: false,
      enabledWorkflowData: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    enabledWorkflowData: null,
  };
};
export const handleEnableWorkflowRequestFailure = (state, action) => {
  createNotification(
    "error",
    "Could not enable the workflow. Please try again!",
    2000,
  );
  return {
    ...state,
    isLoading: false,
    enabledWorkflowData: null,
  };
};

export const handleRunWorkflowRequest = (state, action) => {
  return {
    ...state,
    syncIsLoading: true,
  };
};
export const handleRunWorkflowRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    createNotification(
      "success",
      "All data will be synced shortly. Please come back after a while",
      4000,
    );
    return {
      ...state,
      syncIsLoading: false,
    };
  }
  return {
    ...state,
    syncIsLoading: false,
  };
};
export const handleRunWorkflowRequestFailure = (state, action) => {
  createNotification(
    "error",
    "Could not sync data. Please try again later!",
    2500,
  );
  return {
    ...state,
    syncIsLoading: false,
  };
};

// Gusto Integrations
export const getGustoEmployeeListRequestHandler = (state, action) => {
  return {
    ...state,
    gustoEmployeeLoading: true,
  };
};

export const getGustoEmployeeListSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      gustoEmployeeLoading: false,
      gustoEmployeeList: data.data,
    };
  }
};

export const getGustoEmployeeListFailureHandler = (state, action) => {
  createNotification(
    "error",
    "Could not fetch employee list. Please try again!",
    2500,
  );

  return {
    ...state,
    gustoEmployeeLoading: false,
    gustoEmployeeList: null,
  };
};

export const getGustoCompanyDetailsRequestHandler = (state, action) => {
  return {
    ...state,
    gustoCompanyLoading: true,
  };
};

export const getGustoCompanyDetailsSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      gustoCompanyLoading: false,
      gustoCompanyDetails: data.data,
    };
  }
};

export const getGustoCompanyDetailsFailureHandler = (state, action) => {
  createNotification(
    "error",
    "Could not fetch company details. Please try again!",
    2500,
  );
  return {
    ...state,
    gustoCompanyLoading: false,
    gustoCompanyDetails: null,
  };
};

export const deleteGustoIntegrationRequestHandler = (state, action) => {
  return {
    ...state,
    gustoDeleteLoading: true,
  };
};

export const deleteGustoIntegrationSuccessHandler = (state, action) => {
  createNotification("success", "Gusto integration deleted successfully", 2000);

  return {
    ...state,
    gustoDeleteLoading: false,
    gustoCompanyDetails: null,
    gustoEmployeeList: null,
  };
};

export const deleteGustoIntegrationFailureHandler = (state, action) => {
  createNotification(
    "error",
    "Could not delete the integration. Please try again!",
    2500,
  );
  return {
    ...state,
    gustoDeleteLoading: false,
  };
};

export const updateGustoIntegrationRequestHandler = (state, action) => {
  return {
    ...state,
    gustoUpdateLoading: true,
  };
};

export const updateGustoIntegrationSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;

  createNotification("success", "Gusto integration updated successfully", 2000);
  return {
    ...state,
    gustoUpdateLoading: false,
    gustoCompanyDetails: data.data,
  };
};

export const updateGustoIntegrationFailureHandler = (state, action) => {
  createNotification(
    "error",
    "Could not update the integration. Please try again!",
    2500,
  );
  return {
    ...state,
    gustoUpdateLoading: false,
  };
};

export const bulkGustoInviteRequest = (state, action) => {
  return {
    ...state,
    gustoBulkInviteLoading: true,
  };
};

export const bulkGustoInviteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  console.log("action", action);

  if (data.status == 201) {
    createNotification("success", "Invitations sent successfully", 2000);
    return {
      ...state,
      gustoBulkInviteLoading: false,
    };
  }
  return {
    ...state,
    gustoBulkInviteLoading: false,
  };
};

export const bulkGustoInviteFailure = (state, action) => {
  console.log("action", action);

  createNotification(
    "error",
    "Could not send invitations. Please try again!",
    2500,
  );
  return {
    ...state,
    bulkInviteLoading: false,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_INTEGRATIONS_FEATURES]: handleAllIntegrationsFeaturesRequest,
  [GET_INTEGRATIONS_FEATURES_SUCCESS]:
    handleAllIntegrationsFeaturesRequestSuccess,
  [GET_INTEGRATIONS_FEATURES_FAILURE]:
    handleAllIntegrationsFeaturesRequestFailure,

  [UPDATE_INTEGRATIONS_FEATURES]: updateIntegrationsFeaturesRequest,
  [UPDATE_INTEGRATIONS_FEATURES_SUCCESS]: updateIntegrationsFeaturesSuccess,
  [UPDATE_INTEGRATIONS_FEATURES_FAILURE]: updateIntegrationsFeaturesFailure,

  [GET_ALL_INTEGRATIONS_LIST]: handleAllIntegrationsListRequest,
  [GET_ALL_INTEGRATIONS_LIST_SUCCESS]: handleAllIntegrationsListRequestSuccess,
  [GET_ALL_INTEGRATIONS_LIST_FAILURE]: handleAllIntegrationsListRequestFailure,

  [GET_INTEGRATION_WORKFLOWS_LIST]: handleIntegrationWorkflowsListRequest,
  [GET_INTEGRATION_WORKFLOWS_LIST_SUCCESS]:
    handleIntegrationWorkflowsListRequestSuccess,
  [GET_INTEGRATION_WORKFLOWS_LIST_FAILURE]:
    handleIntegrationWorkflowsListRequestFailure,

  [GET_ENABLED_INTEGRATIONS_LIST]: handleEnabledIntegrationsListRequest,
  [GET_ENABLED_INTEGRATIONS_LIST_SUCCESS]:
    handleEnabledIntegrationsListRequestSuccess,
  [GET_ENABLED_INTEGRATIONS_LIST_FAILURE]:
    handleEnabledIntegrationsListRequestFailure,

  [GET_INTEGRATION_ENABLED_WORKFLOWS_LIST]: handleEnabledWorkflowsListRequest,
  [GET_INTEGRATION_ENABLED_WORKFLOWS_LIST_SUCCESS]:
    handleEnabledWorkflowsListRequestSuccess,
  [GET_INTEGRATION_ENABLED_WORKFLOWS_LIST_FAILURE]:
    handleEnabledWorkflowsListRequestFailure,

  [ENABLE_INTEGRATION_WORKFLOW]: handleEnableWorkflowRequest,
  [ENABLE_INTEGRATION_WORKFLOW_SUCCESS]: handleEnableWorkflowRequestSuccess,
  [ENABLE_INTEGRATION_WORKFLOW_FAILURE]: handleEnableWorkflowRequestFailure,

  [RUN_INTEGRATION_WORKFLOW]: handleRunWorkflowRequest,
  [RUN_INTEGRATION_WORKFLOW_SUCCESS]: handleRunWorkflowRequestSuccess,
  [RUN_INTEGRATION_WORKFLOW_FAILURE]: handleRunWorkflowRequestFailure,

  // Gusto Integrations
  [GET_GUSTO_EMPLOYEE_LIST]: getGustoEmployeeListRequestHandler,
  [GET_GUSTO_EMPLOYEE_LIST_SUCCESS]: getGustoEmployeeListSuccessHandler,
  [GET_GUSTO_EMPLOYEE_LIST_FAILURE]: getGustoEmployeeListFailureHandler,

  [GET_GUSTO_COMPANY_DETAILS]: getGustoCompanyDetailsRequestHandler,
  [GET_GUSTO_COMPANY_DETAILS_SUCCESS]: getGustoCompanyDetailsSuccessHandler,
  [GET_GUSTO_COMPANY_DETAILS_FAILURE]: getGustoCompanyDetailsFailureHandler,

  [UPDATE_GUSTO_COMPANY_LOGO]: "",
  [UPDATE_GUSTO_COMPANY_LOGO_SUCCESS]: "",
  [UPDATE_GUSTO_COMPANY_LOGO_FAILURE]: "",

  [UPDATE_GUSTO_INTEGRATION]: updateGustoIntegrationRequestHandler,
  [UPDATE_GUSTO_INTEGRATION_SUCCESS]: updateGustoIntegrationSuccessHandler,
  [UPDATE_GUSTO_INTEGRATION_FAILURE]: updateGustoIntegrationFailureHandler,

  [DELETE_GUSTO_INTEGRATION]: deleteGustoIntegrationRequestHandler,
  [DELETE_GUSTO_INTEGRATION_SUCCESS]: deleteGustoIntegrationSuccessHandler,
  [DELETE_GUSTO_INTEGRATION_FAILURE]: deleteGustoIntegrationFailureHandler,

  [BULK_GUSTO_INVITE]: bulkGustoInviteRequest,
  [BULK_GUSTO_INVITE_SUCCESS]: bulkGustoInviteSuccess,
  [BULK_GUSTO_INVITE_FAILURE]: bulkGustoInviteFailure,

  [CREATE_GUSTO_PAYROLL_SYNC]: "",
  [CREATE_GUSTO_PAYROLL_SYNC_SUCCESS]: "",
  [CREATE_GUSTO_PAYROLL_SYNC_FAILURE]: "",
};

// default initial state
const initialState = {
  isLoading: false,
  syncIsLoading: false,

  allIntegrationsList: null,
  integrationWorkflowsList: null,

  enabledIntegrationsList: null,
  enabledWorkflowsList: null,
  enabledWorkflowData: null,

  integrationFeaturesLoading: false,
  featuresList: null,

  // Gusto initial state
  gustoEmployeeList: null,
  gustoEmployeeLoading: false,
  gustoCompanyLoading: null,
  gustoCompanyDetails: null,
  gustoBulkInviteLoading: false,
  gustoDeleteLoading: false,
  gustoUpdateLoading: false,
};

export default function IntegrationsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
